import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import { validators } from '../config/security'
import AuthConectSolarLogo from './AuthConectSolarLogo'
import { registrarAcessoUsuario } from '../services/usuariosAcessos'
import './Auth.css'

const LoginSimplificado = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleError = (err, userMessage) => {
    console.error('Erro técnico:', err)
    setError(userMessage || 'Ocorreu um erro inesperado. Tente novamente.')
  }

  const validateForm = () => {
    if (!email.trim()) {
      setError('E-mail é obrigatório')
      return false
    }
    if (!validators.isValidEmail(email)) {
      setError('E-mail inválido')
      return false
    }
    if (!password.trim()) {
      setError('Senha é obrigatória')
      return false
    }
    return true
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    if (!validateForm()) return

    setLoading(true)
    setError('')

    try {
      const emailLowerCase = email.trim().toLowerCase()
      const { data, error: rpcError } = await supabase.rpc('validar_login_usuario', {
        p_email: emailLowerCase,
        p_senha: password
      })

      if (rpcError) {
        const msg = rpcError.message || ''
        if (msg.includes('PGRST203') || msg.includes('Could not choose the best candidate')) {
          throw new Error(
            'Conflito de funções no banco (validar_login_usuario duplicada). Execute database/125_drop_duplicate_auth_functions.sql no Supabase.'
          )
        }
        throw rpcError
      }

      if (data && data.length > 0) {
        const resultado = data[0]
        if (resultado.sucesso) {
          const usuario = {
            id: resultado.usuario_id,
            nome: resultado.nome,
            email: emailLowerCase,
            role: resultado.role,
            empresa_id: resultado.empresa_id
          }
          localStorage.setItem('usuario', JSON.stringify(usuario))
          localStorage.setItem('isAuthenticated', 'true')
          registrarAcessoUsuario({
            usuarioId: usuario.id,
            empresaId: usuario.empresa_id
          })

          if (resultado.primeiro_acesso) {
            navigate('/alterar-senha', {
              state: {
                usuario,
                mensagem: 'Primeiro acesso detectado. Por favor, altere sua senha.'
              }
            })
          } else {
            navigate('/welcome')
          }
        } else {
          setError(resultado.mensagem || 'Credenciais inválidas')
        }
      } else {
        setError('Resposta inválida do servidor')
      }
    } catch (err) {
      const msg = err?.message || ''
      const userMsg = msg.includes('validar_login_usuario duplicada')
        ? msg
        : msg && !msg.includes('Failed to fetch')
          ? msg
          : 'Erro ao fazer login. Verifique suas credenciais.'
      handleError(err, userMsg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-glass-card">
        <div className="auth-header-block">
          <AuthConectSolarLogo />
          <p className="auth-subtitle">Bem-vindo de volta! Entre na sua conta.</p>
        </div>

        {error && (
          <div className="auth-alert auth-alert-error" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="auth-form-modern">
          <div className="auth-field">
            <label htmlFor="email" className="auth-label">
              E-mail
            </label>
            <input
              type="email"
              id="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
              placeholder="nome@exemplo.com"
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>

          <div className="auth-field">
            <div className="auth-label-row">
              <label htmlFor="password" className="auth-label">
                Senha
              </label>
              <Link to="/esqueci-senha" className="auth-link">
                Esqueceu a senha?
              </Link>
            </div>
            <input
              type="password"
              id="password"
              className="auth-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="auth-btn-primary" disabled={loading}>
            {loading ? 'ENTRANDO...' : 'ENTRAR'}
          </button>
        </form>

        <div className="auth-footer">
          <p className="auth-footer-text">
            Dúvidas sobre o acesso?
            <br />
            Entre em contato com o administrador do sistema.
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoginSimplificado
